/* global axios */
import ApiClient from './ApiClient';

class ChatbotsAPI extends ApiClient {
  constructor() {
    super('chatbots', { accountScoped: true });
  }

  assignableBotUsers() {
    return axios.get(`${this.url}/assignable_bot_users`);
  }

  tenantBotConfig() {
    return axios.get(`${this.url}/tenant_bot_config`);
  }

  botUserToken(chatbotId) {
    return axios.get(`${this.url}/${chatbotId}/bot_user_token`);
  }
}

export default new ChatbotsAPI();
